import { ApiError } from '@gorila-shared-ui/components';
import { PaginatedResponse } from '../types/app';
import { Form, FormCore, FormFieldRequest, FormRequest } from '../types/forms';
import { getRequest, postRequest } from './api';
import { URLS } from './urls/urls';

export const getForms = async (
  page: number = 1,
  search: string = '',
  projection: string = 'full'
): Promise<{
  paginatedResponse?: PaginatedResponse<FormCore>;
  error?: ApiError;
}> => {
  const response = await getRequest(URLS.forms.all, {
    queryParams: { page, search, projection },
  });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const createForm = async (form: FormRequest): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(URLS.forms.create, {
    body: form,
  });
  return {
    id: response?.data?._id,
    error: response?.error,
  };
};

export const updateForm = async (formId: string, form: FormRequest): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(URLS.forms.update(formId), {
    body: form,
  });
  return {
    id: response?.data?._id,
    error: response?.error,
  };
};

export const getFormDetail = async (
  formId: string
): Promise<{
  detail?: Form;
  error?: ApiError;
}> => {
  const response = await getRequest(URLS.forms.detail(formId));
  return {
    detail: response?.data,
    error: response?.error,
  };
};

export const createFormField = async (
  formId: string,
  form: FormFieldRequest
): Promise<{ id: string; error?: ApiError }> => {
  const response = await postRequest(URLS.forms.formFields.create(formId), {
    body: form,
  });
  return {
    id: response?.data?._id,
    error: response?.error,
  };
};

export const updateFormField = async (
  formId: string,
  fieldId: string,
  form: FormFieldRequest
): Promise<{ error?: ApiError }> => {
  const response = await postRequest(URLS.forms.formFields.update(formId, fieldId), {
    body: form,
  });
  return {
    error: response?.error,
  };
};

export const sortFormFields = async (
  formId: string,
  items: { _id: string; order: number }[]
): Promise<{ error?: ApiError }> => {
  const response = await postRequest(URLS.forms.formFields.sort(formId), {
    body: {
      items,
    },
  });
  return {
    error: response?.error,
  };
};
